import './footer.component.scss';